export default __webpack_public_path__ + "static/media/orgCic.95013498.png";